module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_3",
      "title": "[Pg 3]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "Third_Day"
    }
  }, [_vm._v("Third Day.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "calibre10"
  }, [_c('img', {
    staticClass: "drop-cap1",
    attrs: {
      "alt": "",
      "id": "id-3946301196875954378",
      "src": "Images/img0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pcalibre verse"
  }, [_vm._v("In the cause of friendship ...")]), _vm._v(" "), _c('div', {
    staticClass: "verse7"
  }, [_vm._v("brave all dangers.")])]), _vm._v(" "), _c('span', {
    staticClass: "calibre11"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Pickwick Papers.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Let us be among the few who do their duty.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Martin Chuzzlewit.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse2"
  }, [_vm._v("Fortune will not bear chiding.")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("We must not reproach her, or she shuns us.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Old Curiosity Shop.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("It is an undoubted fact that all remarkable")]), _vm._v(" "), _c('div', {
    staticClass: "verse7"
  }, [_vm._v("men have had")]), _vm._v(" "), _c('div', {
    staticClass: "verse1"
  }, [_vm._v("remarkable mothers.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Haunted Man.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Every man has his enemies.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Old Curiosity Shop.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0